import React from 'react';
import {Dialog, DialogTitle, DialogContent, withStyles, DialogActions} from '@material-ui/core';
import SessionExpiredForm from "./SessionExpiredForm";
import {connect} from "react-redux";

const styles = theme => ({

});

const SessionExpiredModal = props => {
    const { translations, expired } = props;

    return (
        <Dialog
            open={expired}
            aria-labelledby="expired-session-dialog"
            disableBackdropClick={true}
            disableEscapeKeyDown={true}
            fullWidth={true}
        >
            <DialogTitle id="expired-session-dialog">{translations['session_expired'] || 'Session Expired'}</DialogTitle>
            <DialogContent>
                <SessionExpiredForm translations={translations} />
            </DialogContent>
            <DialogActions>
            </DialogActions>
        </Dialog>
    );
}

const mapStateToProps = state => {
    return {
        translations: state.translate ? state.translate.translations.activeTranslations || {} : {},
        expired: state?.core?.login?.expired,
    };
};

export default connect(mapStateToProps, null)(withStyles(styles)(SessionExpiredModal));